import { ReactNode } from 'react';

import styles from './index.module.scss';

const Footer = ({ children }: { children: ReactNode }) => {
  return <div className={styles['footer']}>{children}</div>;
};

export default Footer;
